import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Order } from 'src/app/models';
import { utils } from '../shared/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class MyDataService {
  private db;

  constructor() {
    //this.openDatabase();
  }

  private openDatabase(): void {
    const request = indexedDB.open('myDatabase', 1);

    request.onupgradeneeded = (event: any) => {
      this.db = event.target.result;
      if (!this.db.objectStoreNames.contains('myStore')) {
        this.db.createObjectStore('myStore', { keyPath: 'id' });
      }
    };

    request.onsuccess = (event: any) => {
      this.db = event.target.result;
    };

    request.onerror = (event: any) => {
      console.error('IndexedDB error:', event.target.error);
    };
  }

  addOrUpdateRecords(data: Order[]): Observable<any> {
    utils.logTimeDiff('Entrou em addOrUpdateRecords');

    return new Observable(resolve => {
      utils.logTimeDiff('Entrou no observable de addOrUpdateRecords');
      const transaction = this.db.transaction(['myStore'], 'readwrite', { durability: 'relaxed' });
      const store = transaction.objectStore('myStore');
      utils.logTimeDiff('Setou transaction e store');

      data.forEach(record => {
        const request = store.put(record);
        request.onsuccess = () => {
          // console.log(`Record with ID ${record.id} added or updated`);
        };
        request.onerror = (event: any) => {
          // console.error(`Error adding/updating record with ID ${record.id}:`, event.target.error);
        };
      });
      utils.logTimeDiff('Salvou no store');

      transaction.oncomplete = () => {
        utils.logTimeDiff('Entrou no transaction.oncomplete');
        resolve.next(0);
        resolve.complete();
      };

      transaction.onerror = (event: any) => {
        resolve.error();
      };

      if (transaction.commit) {
        transaction.commit();
      }
    });
  }

  getAllRecords(): Observable<Order[]> {
    utils.logTimeDiff('Entrou em getAllRecords');

    return new Observable<Order[]>(observer => {
      utils.logTimeDiff('Entrou no observable de getAllRecords');

      const request = indexedDB.open('myDatabase', 1);
      utils.logTimeDiff('indexedDB.open');

      request.onupgradeneeded = (event: any) => {
        this.db = event.target.result;
        if (!this.db.objectStoreNames.contains('myStore')) {
          this.db.createObjectStore('myStore', { keyPath: 'id' });
        }
      };

      request.onsuccess = (event: any) => {
        utils.logTimeDiff('Entrou em request.onsuccess');
        this.db = event.target.result;
        const transaction = this.db.transaction(['myStore'], 'readonly', { durability: 'relaxed' });
        const store = transaction.objectStore('myStore');
        utils.logTimeDiff('setou this.db, transaction e store');
        const request = store.getAll();
        utils.logTimeDiff('setou request');

        request.onsuccess = () => {
          utils.logTimeDiff('entrou em request.onsuccess');
          observer.next(request.result);
          observer.complete();
        };

        request.onerror = (event: any) => {
          observer.error(event.target.error);
        };

        if (transaction.commit) {
          transaction.commit();
        }
      };

      request.onerror = (event: any) => {
        console.error('IndexedDB error:', event.target.error);
      };
    });
  }

  clearStore(): Observable<void> {
    return new Observable<void>(observer => {
      // const request = indexedDB.open('myDatabase', 1);

      // request.onupgradeneeded = (event: any) => {
      //     this.db = event.target.result;
      //     if (!this.db.objectStoreNames.contains('myStore')) {
      //         this.db.createObjectStore('myStore', {keyPath: 'id'});
      //     }
      // };

      // request.onsuccess = (event: any) => {
      //     this.db = event.target.result;
      //     const transaction = this.db.transaction(['myStore'], 'readwrite', { durability: 'relaxed' });
      //     const store = transaction.objectStore('myStore');
      //     const request = store.clear();

      //     request.onsuccess = () => {
      observer.next();
      observer.complete();
      //     };

      //     request.onerror = (event: any) => {
      //         observer.error(event.target.error);
      //     };

      //     if (transaction.commit) {
      //       transaction.commit()
      //     }
      // };

      // request.onerror = (event: any) => {
      //     console.error('IndexedDB error:', event.target.error);
      // };
    });
  }
}
